import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DropdownContainer, DropdownElement } from "./styled/FilterBar";
import CheckboxIcon from "./images/checkbox.svg";
import CheckboxCheckedIcon from "./images/checkbox-checked.svg";
import { setSort } from "../../../features/devices/deviceSlice";

const SortDropdown = ({ visible, setVisible }) => {
  const dispatch = useDispatch();
  const { sort } = useSelector((state) => state.devices);

  const sortOptions = ["featured", "new to old", "old to new"];

  if (visible) {
    return (
      <DropdownContainer right>
        {sortOptions.map((e) => (
          <DropdownElement
            key={e}
            onClick={() =>
              e === sort ? dispatch(setSort("")) : dispatch(setSort(e))
            }
          >
            <img
              src={sort === e ? CheckboxCheckedIcon : CheckboxIcon}
              alt="checkbox"
            />
            <h4>{e}</h4>
          </DropdownElement>
        ))}
      </DropdownContainer>
    );
  }

  return null;
};

export default SortDropdown;
